import { render, staticRenderFns } from "./NeiBuGongShi5.vue?vue&type=template&id=0b281bfd&scoped=true&"
import script from "./NeiBuGongShi5.vue?vue&type=script&lang=js&"
export * from "./NeiBuGongShi5.vue?vue&type=script&lang=js&"
import style0 from "./NeiBuGongShi5.vue?vue&type=style&index=0&id=0b281bfd&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b281bfd",
  null
  
)

export default component.exports